/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompletedStandard,
    CompletedStandardFromJSON,
    CompletedStandardFromJSONTyped,
    CompletedStandardToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompletedStandardsSummary
 */
export interface CompletedStandardsSummary {
    /**
     * 
     * @type {boolean}
     * @memberof CompletedStandardsSummary
     */
    isPublic: boolean;
    /**
     * 
     * @type {Array<CompletedStandard>}
     * @memberof CompletedStandardsSummary
     */
    list?: Array<CompletedStandard>;
}

export function CompletedStandardsSummaryFromJSON(json: any): CompletedStandardsSummary {
    return CompletedStandardsSummaryFromJSONTyped(json, false);
}

export function CompletedStandardsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedStandardsSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isPublic': json['is_public'],
        'list': !exists(json, 'list') ? undefined : ((json['list'] as Array<any>).map(CompletedStandardFromJSON)),
    };
}

export function CompletedStandardsSummaryToJSON(value?: CompletedStandardsSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_public': value.isPublic,
        'list': value.list === undefined ? undefined : ((value.list as Array<any>).map(CompletedStandardToJSON)),
    };
}


